<script lang="ts">
	import { chart, SvelteApexChartsConfig } from 'svelte-apexcharts';
	import { userClientData } from '../../stores';

	export let xAxis: number[];
	export let yAxis: number[];

	export let percent: number;
	export let ratio: number;

	let options = {
		series: [
			{
				name: 'Ratio of target cookies',
				data: yAxis.map((value: number) => {
					return value.toFixed(3);
				})
			}
		],
		chart: {
			height: 350,
			fontFamily: 'nexa, sans-serif',
			type: 'line',
			zoom: {
				enabled: false
			},
			toolbar: {
				show: false
			},
			events: {
				dataPointSelection: function (
					event: any,
					chartContext: any,
					config: SvelteApexChartsConfig
				) {
					console.log(event);
					console.log(chartContext);
					ratio = parseFloat(options.series[0].data[config.dataPointIndex]);
					percent = parseInt(options.xaxis.categories[config.dataPointIndex]);
				}
			}
		},
		dataLabels: {
			enabled: false
		},
		stroke: {
			curve: 'straight'
		},
		grid: {
			row: {
				colors: ['#f3f3f3', 'transparent'], // takes an array which will be repeated on columns
				opacity: 0.5
			}
		},
		xaxis: {
			title: {
				text: 'Percent of traffic',
				style: {
					fontSize: '17px'
				}
			},
			categories: xAxis.map((value: number, index: number) => {
				return index * 5 * (value / value) + '%';
			})
		},
		yaxis: {
			title: {
				text: 'Ratio of target cookies',
				style: {
					fontSize: '17px'
				}
			}
		},
		markers: {
			size: 12
		},
		tooltip: {
			shared: false,
			intersect: true
		},
		colors: [$userClientData.webData.primaryColor]
	};
</script>

<div use:chart={options} style="width: 100%; min-height: 200px" />

<style>
	@keyframes scaling {
		0% {
			r: 12;
		}
		50% {
			r: 15;
		}
		100% {
			r: 12;
		}
	}

	:global(.apexcharts-marker) {
		cursor: pointer;
	}

	:global(.apexcharts-marker[selected='true']) {
		fill: #1a9afb;
		filter: none;
		animation: scaling 2s linear;
		animation-iteration-count: infinite;
	}
</style>
